// this is an autogenerated file from DesignSystem/TasksMoveModal/Board/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksMoveModal_Board(
  $location_id: uuid!
  $board_ids: [uuid!]!
  $assignee_ids: [uuid!]
  $hasAssignee: Boolean!
) {
  tasks_boards(
    where: {
      status: { _eq: active }
      id: { _nin: $board_ids }
      metadata: { _contains: { locations: [$location_id] } }
    }
    order_by: { name: asc }
  ) {
    id
    text: name
    metadata
  }
  app_admin_users_access(where: { user_id: { _in: $assignee_ids } })
    @include(if: $hasAssignee) {
    id
    organization_id
  }
}

`